"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dialogPromiseHandler = exports.dialogContentHandler = void 0;
exports.ContentDialog = ContentDialog;
var jsx_runtime_1 = require("react/jsx-runtime");
var content_dialog_1 = require("../../features/thunks/content-dialog");
var hooks_1 = require("../../store/hooks");
var dialogContentHandler = {
    body: (0, jsx_runtime_1.jsx)("div", { children: "Default Content Handler" }),
};
exports.dialogContentHandler = dialogContentHandler;
var dialogPromiseHandler = {
    resolve: null,
};
exports.dialogPromiseHandler = dialogPromiseHandler;
function ContentDialog() {
    var _a = (0, hooks_1.useAppSelector)(function (state) { return state.contentDialog; }), isOpen = _a.isOpen, header = _a.header, width = _a.width, closable = _a.closable;
    var dispatch = (0, hooks_1.useAppDispatch)();
    // Use the LEWFIN brand red color as default for all modals
    var primaryColor = "#ca2128";
    // Check if this is the My Account modal by checking if header is empty (My Account modal uses empty header)
    var isMyAccountModal = !header || header === "";
    // Dynamic width and position styles based on width prop
    var getWidthStyles = function () {
        switch (width) {
            case "narrow":
                return { maxWidth: "250px", width: "100%" };
            case "normal":
                return { maxWidth: "300px", width: "100%" };
            case "wide":
                return { maxWidth: "500px", width: "100%" };
            case "full":
                // For centered full-width modals, use explicit left/right positioning
                var fullWidth = isMyAccountModal ? "60vw" : "90vw";
                var margin = isMyAccountModal ? "20vw" : "5vw";
                return { width: fullWidth, left: margin, right: margin };
            default:
                return { maxWidth: "300px", width: "100%" };
        }
    };
    // Dynamic positioning based on modal type and width
    var getPositionStyles = function () {
        if (isMyAccountModal) {
            // Centered via left/right in getWidthStyles
            return "absolute top-[100px]";
        }
        // Full-width modals are centered via left/right in getWidthStyles
        if (width === "full") {
            return "absolute top-[100px]";
        }
        return "absolute top-[100px] right-4";
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isOpen && ((0, jsx_runtime_1.jsxs)("div", { className: "fixed inset-0 z-50", children: [(0, jsx_runtime_1.jsx)("div", { className: "absolute inset-0 bg-black/50", onClick: function () { return closable && dispatch((0, content_dialog_1.closeContentDialogThunk)()); } }), (0, jsx_runtime_1.jsxs)("div", { className: getPositionStyles(), style: getWidthStyles(), children: [closable && ((0, jsx_runtime_1.jsx)("button", { onClick: function () { return dispatch((0, content_dialog_1.closeContentDialogThunk)()); }, className: "absolute top-0 -left-5 w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-lg z-10", style: { backgroundColor: primaryColor }, children: "\u00D7" })), (0, jsx_runtime_1.jsxs)("div", { className: "bg-white rounded-lg shadow-xl w-full max-h-[calc(100vh-2rem)] overflow-y-auto", children: [(0, jsx_runtime_1.jsx)("div", { className: "px-6 ".concat(!isMyAccountModal ? "pt-8" : ""), children: (0, jsx_runtime_1.jsx)("h2", { className: "text-2xl font-bold text-gray-900", children: header !== null && header !== void 0 ? header : "No Header" }) }), (0, jsx_runtime_1.jsx)("div", { className: "p-0", children: dialogContentHandler["body"] })] })] })] })) }));
}
